<template>
  <div class="text-center container">
    <div>
      <img :src="getImage()" height="40px" />
    </div>
    <div class="mt-2 caption" style="font-size: 0.70rem !important">
      <span>&#169; {{ getFooterTitle() }}. All rights reserved.</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortalFooter',
  methods: {
    getFooterTitle() {
      return process.env.VUE_APP_FOOTER_TITLE
    },
    getImage() {
      return require(`../Assets/Images/${process.env.VUE_APP_FOOTER_LOGO}`)
    }
  }
}
</script>

<style scoped>
.container {
  /* margin-top: 120px; */
}
</style>
